import React from "react";
import "./ActionCard.css";

export default function ActionCard({ title, description, onClick }) {
  return (
    <div className="action-card" onClick={onClick} role="button" tabIndex={0}>
      <div className="action-title">{title}</div>
      <div className="action-desc">{description}</div>
    </div>
  );
}
